import React, { useEffect, useState, useRef } from "react";
import { BiSearch } from "react-icons/bi";
import InputComponent from "./InputComponent";
import DropDownComponent from "./DropDownComponent";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./../assets/sass/style.css";
import "./../assets/sass/style.scss";
import gif from "./../assets/img/spin.gif";
import { MdContentCopy, MdCheck } from "react-icons/md";
import { API_Link, validateHeader } from "../commons/Constants";
import { useSelector, useDispatch } from "react-redux";
import { getPermission } from "../features/setting/permissionSlice";

function SearchingInclusion(props) {
  const [getPermission, setGetPermission] = useState([]);
  const MD5hash = validateHeader();
  const navigate = useNavigate();
  const [optionSelected, setOptionSelected] = useState("");
  const [population, setPopulation] = useState("");
  const [intervention, setIntervention] = useState("");
  const [comparison, setComparison] = useState("");
  const [outcomes, setOutcomes] = useState("");
  const [exclude, setExclude] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [picoSearchs, setPicoSearches] = useState([]);
  const [copyText, setCopyText] = useState("Get Query");
  const [suggestions, setSuggestions] = useState({});
  const [copiedButtonIndex, setCopiedButtonIndex] = useState(null);
  const dropdownRef = useRef(null);
  //

  const user = JSON.parse(localStorage.getItem("user"));
  const token = user?.token;

  const getPermissionCall = () => {
    setIsLoading(true);
    var config = {
      method: "get",
      url: `${API_Link}getAllowedStages?review_id=${localStorage.getItem(
        "studyId"
      )}`,
      headers: {
        "misr-auth": MD5hash,
        Authorization: `Bearer ${token}`,
      },
    };
    axios(config)
      .then(function (response) {
        setGetPermission(response.data.permissions[0]);

        // console.log("after api call in search inclusion", getPermission);
      })
      .catch(function (error) {
        console.log(error);
      });

    setIsLoading(false);
  };

  const getPicoSearches = () => {
    let review_id = localStorage.getItem("studyId");

    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;

    var config = {
      method: "get",
      url: `${API_Link}getPicoSearches?review_id=${review_id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    axios(config)
      .then(function (response) {
        setPicoSearches(
          response.data.picoSearches.filter(
            (item) => item.database !== "RISimport"
          )
        );
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    getPicoSearches();
    getPermissionCall();
  }, [optionSelected]);

  // console.log("picoSearchs", picoSearchs);
  // "Database":"PubMed",
  // "Population": "The population of patients with eczema",
  // "Intervention": "The intervention of probiotics",
  // "Comparison": "In comparison to no treatment, placebo, or non-probiotic treatment",
  // "Outcomes": "The outcome of changes in participant-, parent-, and doctor-rated symptoms of eczema and quality of life",
  // "Exclusion": "animals"
  //
  let handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    var data = JSON.stringify({
      email: user.user.email,
      Database: optionSelected,
      Population: population,
      Intervention: intervention,
      Comparison: comparison,
      Outcomes: outcomes,
      Exclusion: exclude,
      start: 1,
    });

    // var config = {
    //   method: 'post',
    //   url: 'http://misr.pacemis.com:92/search',
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    //   data: data,
    // };

    const config = {
      method: "post",
      url: `${API_Link}getSearchArticles`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.articles.length === 0) {
          navigate("/searchingInclusion");
        }
        // console.log("resData111", response.data.articles.length);
        if (response.data.articles.length < 1000) {
          const resData = JSON.stringify(response.data.articles);
          const query = JSON.stringify(response.data.info);
          // console.log("resData", resData);
          localStorage.setItem("search", "");
          localStorage.setItem("PICO", 1);
          localStorage.setItem("picoData", data);
          const localresData = localStorage.setItem("search", resData);
          const info = localStorage.setItem("info", query);
          // console.log("resposee", localresData.length);
          if (localresData !== null) {
            navigate("/listingselections");
          }
        }
        if (response.data.articles.length >= 1000) {
          // const resData = JSON.stringify(response.data);
          const resData = JSON.stringify(response.data.articles);
          const query = JSON.stringify(response.data.info);
          // console.log("resData", resData);
          localStorage.setItem("search", "");
          localStorage.setItem("PICO", 1);
          localStorage.setItem("picoData", data);
          const localresData = localStorage.setItem("search", resData);
          const info = localStorage.setItem("info", query);
          // console.log("resposee", localresData.length);
          if (localresData !== null) {
            navigate("/listingselections");
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        alert(error);
      })
      .finally(() => setIsLoading(false));
  };
  // const fetchSuggestion = async (type, value) => {
  //   if (value.length > 2) {
  //     // Trigger suggestions after 2 characters
  //     try {
  //       const response = await axios.get(
  //         `https://www.dictionaryapi.com/api/v3/references/medical/json/${value}?key=0be39275-5c8e-4736-8efa-744322e0b3d7`
  //       );
  //       const data = response.data;
  //       console.log("Data", data);
  //       // Always assume data is in the first response format if available
  //       let suggestionsArray = [];

  //       if (Array.isArray(data)) {
  //         if (typeof data[0] === "string") {
  //           // Condition 1: Array of strings
  //           suggestionsArray = data; // this is the first type of response
  //         } else if (typeof data[0] === "object" && data[0]?.meta?.stem) {
  //           // Condition 2: Array of objects
  //           suggestionsArray = data.meta.stems;
  //         }
  //       }

  //       // Set suggestions state
  //       setSuggestions((prev) => ({
  //         ...prev,
  //         [type]: suggestionsArray,
  //       }));
  //     } catch (error) {
  //       console.error("Error fetching thesaurus data", error);
  //     }
  //   }
  // };
  const fetchSuggestion = async (type, value) => {
    const payload = {
      word: value,
      data_base: "pubMeD",
      search_in:
        type === "exclude"
          ? "exclusion"
          : type === "outcomes"
          ? "outcome"
          : type,
    };
    if (value.length > 2) {
      const config = {
        method: "post",
        url: `${API_Link}getPicoSuggestion`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          "misr-auth": MD5hash,
        },
        data: payload,
      };
      try {
        const response = await axios(config);
        setSuggestions((prev) => ({
          ...prev,
          [type]: response?.data?.picoSuggestions,
        }));
      } catch (error) {
        console.error("Error fetching thesaurus data", error);
      }
    }
  };

  const handleChange = async (type, value) => {
    switch (type) {
      case "databaseid":
        setOptionSelected(value);
        break;

      case "intervention":
        setIntervention(value.target.value);
        fetchSuggestion(type, value.target.value);
        // console.log("intervention handle change",value.target.value)
        break;

      case "comparison":
        setComparison(value.target.value);
        fetchSuggestion(type, value.target.value);
        break;

      case "outcomes":
        setOutcomes(value.target.value);
        fetchSuggestion(type, value.target.value);
        break;

      case "population":
        setPopulation(value.target.value);
        fetchSuggestion(type, value.target.value);
        break;

      case "exclude":
        setExclude(value.target.value);
        fetchSuggestion(type, value.target.value);
        break;

      default:
        break;
    }
  };

  const handleSuggestionClick = (type, value) => {
    switch (type) {
      case "intervention":
        setIntervention(value);
        break;

      case "comparison":
        setComparison(value);
        break;

      case "outcomes":
        setOutcomes(value);
        break;

      case "population":
        setPopulation(value);
        break;

      case "exclude":
        setExclude(value);
        break;

      default:
        break;
    }
    setSuggestions((prev) => ({
      ...prev,
      [type]: [], // Clear suggestions
    }));
  };

  const getPicoSearch = (search) => {
    setOptionSelected(search.database);
    setIntervention(search.intervention === null ? "" : search.intervention);
    setComparison(search.comparison === null ? "" : search.comparison);
    setPopulation(search.population === null ? "" : search.population);
    setOutcomes(search.outcome === null ? "" : search.outcome);
    setExclude(search.exclusion === null ? "" : search.exclusion);
  };

  const database_options = [
    {
      value: "",
      label: "Please select database type",
    },
    {
      value: "pubMeD",
      label: "PubMeD",
    },
  ];

  if (isLoading)
    return (
      <div className="preload">
        <img src={gif} alt="" />
      </div>
    );

  // click outside to remove drop down
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setSuggestions({});
    }
  };

  const handleCopyText = (text, index) => {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(() => {
        setCopiedButtonIndex(index); // Set the copied button index
        setTimeout(() => setCopiedButtonIndex(null), 2000); // Reset after 2 seconds
      });
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        setCopiedButtonIndex(index); // Set the copied button index
        setTimeout(() => setCopiedButtonIndex(null), 2000); // Reset after 2 seconds
      } catch (err) {
        console.error("Fallback copy failed", err);
      }
      document.body.removeChild(textArea);
    }
  };
  return (
    <div className="page--content" onClick={handleClickOutside}>
      <div className=" inclusion-sticky-title">
        <h1 className="page--heading">Inclusion Criterion</h1>
      </div>

      <div className="white--bg">
        <form onSubmit={handleSubmit}>
          <div className="mb-3 row">
            <label className="col-sm-12 col-md-3 col-lg-2 col-form-label">
              Database
            </label>
            <div className="col-sm-12  col-md-9 col-lg-10 custom--form--control">
              <DropDownComponent
                selected={optionSelected}
                id={"databaseid"}
                options={database_options}
                icon={"fas fa-chevron-down"}
                handleChange={handleChange}
              />
            </div>
          </div>

          <div className="mb-3 row">
            <label className="col-sm-12 col-md-3 col-lg-2 col-form-label">
              Population
            </label>
            <div className="col-sm-12 col-md-9 col-lg-10">
              <div className="relative" ref={dropdownRef}>
                {" "}
                {/* Add a relative class here */}
                <div className="chips input-field suggestion-field">
                  <InputComponent
                    for={"population"}
                    type={"text"}
                    name="population"
                    placeholder={"Search a review"}
                    onChange={handleChange}
                    value={population}
                  />
                  {suggestions?.population?.length > 0 && (
                    <ul className="absolute   mt-1 shadow-lg">
                      {suggestions?.population?.map((suggestion, idx) => (
                        <li
                          key={idx}
                          className="px-4 py-2 text-gray-700 cursor-pointer hover:bg-gray-100"
                          onClick={() =>
                            handleSuggestionClick("population", suggestion)
                          }
                        >
                          {suggestion}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="mb-3 row">
            <label className="col-sm-12 col-md-3 col-lg-2 col-form-label">
              Intervention
            </label>
            <div className="col-sm-12  col-md-9 col-lg-10">
              <div className="" ref={dropdownRef}>
                <div className="chips input-field suggestion-field">
                  <InputComponent
                    for={"intervention"}
                    type={"text"}
                    name="intervention"
                    placeholder={"Search a review"}
                    onChange={handleChange}
                    is_optional={true}
                    value={intervention}
                  />
                  {suggestions?.intervention?.length > 0 && (
                    <ul className="absolute   mt-1 shadow-lg">
                      {suggestions?.intervention?.map((suggestion, idx) => (
                        <li
                          key={idx}
                          className="px-4 py-2 text-gray-700 cursor-pointer hover:bg-gray-100"
                          onClick={() =>
                            handleSuggestionClick("intervention", suggestion)
                          }
                        >
                          {suggestion}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="mb-3 row">
            <label className="col-sm-12 col-md-3 col-lg-2 col-form-label">
              Comparison
            </label>
            <div className="col-sm-12  col-md-9 col-lg-10">
              <div className="">
                <div className="chips input-field suggestion-field">
                  <InputComponent
                    for={"comparison"}
                    type={"text"}
                    name="comparison"
                    placeholder={"Search a review"}
                    onChange={handleChange}
                    is_optional={true}
                    value={comparison}
                  />
                  {suggestions?.comparison?.length > 0 && (
                    <ul className="absolute   mt-1 shadow-lg">
                      {suggestions?.comparison?.map((suggestion, idx) => (
                        <li
                          key={idx}
                          className="px-4 py-2 text-gray-700 cursor-pointer hover:bg-gray-100"
                          onClick={() =>
                            handleSuggestionClick("comparison", suggestion)
                          }
                        >
                          {suggestion}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="mb-3 row">
            <label className="col-sm-12 col-md-3 col-lg-2 col-form-label">
              Outcomes
            </label>
            <div className="col-sm-12  col-md-9 col-lg-10">
              <div className="" ref={dropdownRef}>
                <div className="chips input-field suggestion-field">
                  <InputComponent
                    for={"outcomes"}
                    type={"text"}
                    name="outcomes"
                    placeholder={"Search a review"}
                    onChange={handleChange}
                    is_optional={true}
                    value={outcomes}
                  />
                  {suggestions?.outcomes?.length > 0 && (
                    <ul className="absolute   mt-1 shadow-lg">
                      {suggestions?.outcomes?.map((suggestion, idx) => (
                        <li
                          key={idx}
                          className="px-4 py-2 text-gray-700 cursor-pointer hover:bg-gray-100"
                          onClick={() =>
                            handleSuggestionClick("outcomes", suggestion)
                          }
                        >
                          {suggestion}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="mb-3 row">
            <label className="col-sm-12 col-md-3 col-lg-2 col-form-label">
              Exclude
            </label>
            <div className="col-sm-12  col-md-9 col-lg-10">
              <div className=" " ref={dropdownRef}>
                <div className="chips input-field suggestion-field">
                  <InputComponent
                    for={"exclude"}
                    type={"text"}
                    name="exclude"
                    placeholder={"Search a review"}
                    onChange={handleChange}
                    is_optional={true}
                    value={exclude}
                  />
                  {suggestions?.exclude?.length > 0 && (
                    <ul className="absolute   mt-1 shadow-lg">
                      {suggestions?.exclude?.map((suggestion, idx) => (
                        <li
                          key={idx}
                          className="px-4 py-2 text-gray-700 cursor-pointer hover:bg-gray-100"
                          onClick={() =>
                            handleSuggestionClick("exclude", suggestion)
                          }
                        >
                          {suggestion}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="mb-3 row form--submit">
            <div className="col-sm-12 text-end">
              <button type="submit" className="btn--submit">
                <BiSearch /> Search
              </button>
            </div>
          </div>
        </form>
      </div>

      {/*  */}
      <div className="table-div mt-5">
        <h4>
          <strong>Pico Search History</strong>
        </h4>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Database</th>
              <th>Population</th>
              <th>Intervention</th>
              <th>Comparison</th>
              <th>Outcomes</th>
              <th>Exclude</th>
              <th>Included</th>
              <th>Total</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {picoSearchs?.length > 0 ? (
              picoSearchs?.map((search, index) => (
                <tr key={index}>
                  <td>{search.database}</td>
                  <td>{search.population}</td>
                  <td>{search.intervention}</td>
                  <td>{search.comparison}</td>
                  <td>{search.outcome}</td>
                  <td>{search.exclusion}</td>
                  <td>{search.included}</td>
                  <td>{search.total_records}</td>
                  <td>
                    {getPermission && getPermission?.includes(1) ? (
                      <>
                        <button
                          id={search.id}
                          className="btn--submit"
                          onClick={() => getPicoSearch(search)}
                        >
                          {" "}
                          Use PICO
                        </button>
                        {search.pubmid_query && (
                          <button
                            className="btn--submit m-1"
                            onClick={() =>
                              handleCopyText(search.pubmid_query, index)
                            }
                          >
                            {copiedButtonIndex === index ? (
                              <span>
                                <MdCheck size={18} /> <span>Copied!</span>
                              </span>
                            ) : (
                              <span>
                                <MdContentCopy size={18} />{" "}
                                <span>Get Query</span>
                              </span>
                            )}
                          </button>
                        )}
                      </>
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className="text-center text-muted">
                  You have no pico search History
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/*  */}
    </div>
  );
}

export default SearchingInclusion;
